import type { RequestPdfParams } from '@/apis/pdf.types';

import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

export type * from '@/apis/pdf.types';

export const http = createDashHttpClient(env.pdfApiUrl);

export async function requestPdf(
  {
    url,
    filename,
    notificationSocketId,
    notificationMeta,
    width,
    height,
    format,
    landscape,
    scale,
    idleTimeout,
    idleMaxInflightRequest,
    useWaitFor,
    margin,
  }: RequestPdfParams,
  config: HttpRequestConfig = {},
) {
  return http.post(
    `pdfs`,
    {
      url,
      filename,
      notificationSocketId,
      notificationMeta,
      width,
      height,
      format,
      landscape,
      scale,
      idleTimeout,
      idleMaxInflightRequest,
      useWaitFor,
      margin,
      delay: 15,
    },
    config,
  );
}
